export default __webpack_public_path__ + "static/media/1959.7c3f4d54.png";